<template>
  <work v-if="project">
    <work-project v-bind="project" :key="project.id" />
  </work>
</template>

<script>
import store from 'store'
import Work from '@/app/components/work/Work.vue'
import WorkProject from '@/app/components/work/WorkProject.vue'
import { ADMIN_PROJECTS_KEY } from 'dayjob'

export default {
  name: 'AdminProjectPreview',

  metaInfo: {
    title: 'Project Preview'
  },

  components: {
    Work,
    WorkProject
  },

  computed: {
    project() {
      const slug = this.$route.params.slug
      const projects = store.get(ADMIN_PROJECTS_KEY)
      const project = projects[slug]
      return project
    }
  }
}
</script>
